import React from 'react';

import { ToggleButton } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { PageRenderingButton, SupporterVideo } from '../../shared/types';
import { useLikeVideo } from '../LikeVideo/hooks/useLikeVideo';

type LikeVideoProps = {
	video: SupporterVideo;
	petitionId: string;
	renderedOn: PageRenderingButton;
};

export const LikeVideoButton: React.FC<LikeVideoProps> = ({ video, petitionId, renderedOn }) => {
	const {
		data: { isVideoLiked, videoLikeCount, isGuest },
		actions: { handleLikeClick },
	} = useLikeVideo({ video, petitionId, renderedOn });

	const { translate, localizeNumber } = useI18n();

	if (isGuest) {
		return null;
	}

	const ariaLabel = isVideoLiked
		? translate('corgi.components.petition_video.actions.aria_label.unlike_video', {
				user_name: video.user?.shortDisplayName ?? '',
			})
		: translate('corgi.components.petition_video.actions.aria_label.like_video', {
				user_name: video.user?.shortDisplayName ?? '',
			});

	return (
		<ToggleButton
			variant="like"
			data-testid={`supporter-video-${video.id}-like-button-combo`}
			className="text-typography-inverse-strong flex flex-row items-center gap-2"
			counter={videoLikeCount === 0 ? undefined : localizeNumber(videoLikeCount)}
			isSelected={isVideoLiked ?? false}
			onChange={handleLikeClick}
			aria-label={ariaLabel}
		/>
	);
};
